export default "__VITE_ASSET__DoNODFzA__";